import { Component, Input} from '@angular/core';
import { SessionService } from '../../services/session';


@Component({
  selector: 'app-class-list-item',
  templateUrl: 'class-list-item.html'
})
export class ClassListItemComponent {
  @Input() lesson: any;
  constructor(public sessionService: SessionService){

  }
}



// WEBPACK FOOTER //
// ./src/components/class-list-item/class-list-item.ts